import { Service } from "./service.model";

export class Services {
    constructor(
        public readonly services: Service[],
        public readonly count: number,
    ) {}
}
